import moment from 'moment-timezone';

var TODAY = 'today';
var THIS_WEEK = 'thisWeek';
var LAST_WEEK = 'lastWeek';
var THIS_MONTH = 'thisMonth';
var LAST_MONTH = 'lastMonth';
var CUSTOM = 'custom';
var getStateFromNewSelectedRange = function (newSelectedRange, timeZone) {
    var startDate = null;
    var endDate = null;
    var selectedRange = CUSTOM;
    var focusedInput = 'startDate';
    var momentStart = moment().tz(timeZone);
    var momentEnd = moment().tz(timeZone);
    switch (newSelectedRange) {
        case TODAY:
            startDate = momentStart.startOf('day');
            endDate = momentEnd.endOf('day');
            selectedRange = TODAY;
            focusedInput = null;
            break;
        case THIS_WEEK:
            startDate = momentStart.startOf('week');
            endDate = momentEnd.endOf('week');
            selectedRange = THIS_WEEK;
            focusedInput = null;
            break;
        case LAST_WEEK:
            startDate = momentStart.subtract(1, 'week').startOf('week');
            endDate = momentEnd.subtract(1, 'week').endOf('week');
            selectedRange = LAST_WEEK;
            focusedInput = null;
            break;
        case THIS_MONTH:
            startDate = momentStart.startOf('month');
            endDate = momentEnd.endOf('month');
            selectedRange = THIS_MONTH;
            focusedInput = null;
            break;
        case LAST_MONTH:
            startDate = momentStart.subtract(1, 'month').startOf('month');
            endDate = momentEnd.subtract(1, 'month').endOf('month');
            selectedRange = LAST_MONTH;
            focusedInput = null;
            break;
        case CUSTOM:
            startDate = momentStart.startOf('day');
            endDate = momentEnd.endOf('day');
            selectedRange = CUSTOM;
            focusedInput = 'startDate';
            break;
        default:
            startDate = momentStart.startOf('day');
            endDate = momentEnd.endOf('day');
            selectedRange = TODAY;
            focusedInput = null;
            break;
    }
    return {
        startDate: startDate,
        endDate: endDate,
        selectedRange: selectedRange,
        focusedInput: focusedInput,
    };
};
var getTimezone = function (timezone) {
    return timezone.length
        ? timezone
        : Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export { getStateFromNewSelectedRange, getTimezone };
